// Public API of the offline tracker store. Other tabs (Plan) read and write entries through this module.
//   const entries = useEntries(baby.id, { from, to });     // live, local-first
//   await addEntry(baby.id, { type: 'sleep', startAt, endAt: null, data: {} });
//   await stopTimer(id); await updateEntry(id, patch); const snap = await removeEntry(id); await undoRemove(snap);
export type { LocalEntry, ServerEntry, EntryInput } from './db';
export { openStore, clearStore } from './db';
export { addEntry, updateEntry, removeEntry, undoRemove, stopTimer, UNDO_MS, type EntryPatch } from './entries';
export { useEntries, useOpenEntries, useLatest, useLastEntryAt, useEntry, usePendingCount, useSyncState, useBabySync, useLiveQuery, useStoreOpen, type Range } from './hooks';
export { syncNow, requestSync, onSyncNotice, type SyncNotice, type SyncState } from './sync';
